import React, { createContext, useState } from "react";
import { UserContextType, UserType } from "../../types/context";

export const DataContext = createContext<UserContextType | undefined>(undefined);

export const DataProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<UserType | null>(null);
  return <DataContext.Provider value={{ user, setUser }}>{children}</DataContext.Provider>;
};

export const useUserContext = () => {
  const context = React.useContext(DataContext);
  if (context === undefined) {
    throw new Error("useUserContext must be used within a DataProvider");
  }
  return context;
};
